import { Link } from "react-router-dom";

const footerColumns = [
  {
    title: "浏览栏目",
    links: [
      { to: "/", label: "首页推荐" },
      { to: "/categories", label: "题材分类" },
      { to: "/rankings", label: "人气榜单" },
    ],
  },
  {
    title: "关于我们",
    links: [
      { to: "/about", label: "网站定位" },
      { to: "/about", label: "内容原则" },
      { to: "/about", label: "用户口碑" },
    ],
  },
  {
    title: "热门题材",
    links: [
      { to: "/categories#sweet", label: "甜宠浪漫" },
      { to: "/categories#fantasy", label: "奇幻冒险" },
      { to: "/categories#mystery", label: "悬疑烧脑" },
      { to: "/categories#healing", label: "治愈日常" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-background-100 border-t border-background-200/70">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2.5" aria-label="正版韩漫大全首页">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-book-open-line text-lg"></i>
              </span>
              <span className="font-heading text-lg text-primary-600">韩漫大全</span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              正版韩漫题材分类聚合平台，从甜宠到悬疑、从奇幻到现实，人气推荐一页全览，帮你快速定位想看的韩漫。
            </p>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title}>
              <h4 className="font-medium text-foreground-900">{col.title}</h4>
              <ul className="mt-4 space-y-3">
                {col.links.map((link, i) => (
                  <li key={i}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-4 border-t border-background-200/70 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 正版韩漫大全 · 尊重版权，支持正版，让每一份热爱都被温柔以待
          </p>
          <div className="flex items-center gap-3 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-shield-check-line"></i> 正规授权
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-heart-3-line"></i> 用心推荐
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}